import React, { lazy, Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'

import Layout from 'layouts'

const routes = [
  // Dashboards
  {
    path: '/dashboard',
    Component: lazy(() => import('pages/dashboard/alpha')),
    exact: true,
    permission: 'dashboard',
  },
  {
    path: '/merchants',
    Component: lazy(() => import('pages/merchants/list')),
    exact: true,
    permission: 'merchants',
  },
  // Payments
  {
    path: '/transaction',
    Component: lazy(() => import('pages/transaction/list')),
    exact: true,
    permission: 'transactions',
  },
  {
    path: '/transaction/:paymentId',
    Component: lazy(() => import('pages/transaction/details')),
    exact: true,
    permission: 'transactions',
  },
  {
    path: '/sub-agents',
    Component: lazy(() => import('pages/subAgents')),
    exact: true,
    permission: 'subAgents',
  },
  {
    path: '/payout-history',
    Component: lazy(() => import('pages/payoutHistory')),
    exact: true,
    permission: 'payoutHistory',
  },
  // Auth Pages
  {
    path: '/auth/login/:token?',
    Component: lazy(() => import('pages/auth/login')),
    exact: true,
  },
  {
    path: '/auth/forgot-password',
    Component: lazy(() => import('pages/auth/forgot-password')),
    exact: true,
  },
  {
    path: '/auth/register',
    Component: lazy(() => import('pages/auth/register')),
    exact: true,
  },
  {
    path: '/auth/lockscreen',
    Component: lazy(() => import('pages/auth/lockscreen')),
    exact: true,
  },
  {
    path: '/auth/404',
    Component: lazy(() => import('pages/auth/404')),
    exact: true,
  },
  {
    path: '/auth/500',
    Component: lazy(() => import('pages/auth/500')),
    exact: true,
  },
]

const mapStateToProps = ({ settings, user }) => ({
  routerAnimation: settings.routerAnimation,
  permissions: user.permissions,
})

const Router = ({ history, routerAnimation, permissions }) => {
  return (
    <ConnectedRouter history={history}>
      <Layout>
        <Route
          render={state => {
            const { location } = state
            return (
              <SwitchTransition>
                <CSSTransition
                  key={location.pathname}
                  appear
                  classNames={routerAnimation}
                  timeout={routerAnimation === 'none' ? 0 : 300}
                >
                  <Switch location={location}>
                    <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
                    {routes.map(({ path, Component, exact, permission }) => (
                      <Route
                        path={path}
                        key={path}
                        exact={exact}
                        render={props => {
                          if (permission && permissions && permissions[permission] === false) {
                            return <Redirect to="/auth/404" />
                          }
                          return (
                            <div className={routerAnimation}>
                              <Suspense fallback={null}>
                                <Component {...props} />
                              </Suspense>
                            </div>
                          )
                        }}
                      />
                    ))}
                    <Redirect to="/auth/404" />
                  </Switch>
                </CSSTransition>
              </SwitchTransition>
            )
          }}
        />
      </Layout>
    </ConnectedRouter>
  )
}

export default connect(mapStateToProps)(Router)
